import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#005293",
      d: "M0 0h640v480H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fecb00",
      d: "M176 0v192H0v96h176v192h96V288h368v-96H272V0z"
    }, null, -1)
  ]))]))
}
export default { render: render }